<template>
  <base-modal :open="openModal" @close="close">
    <div slot="header">
      <button type="button" class="close" @click="close">
        <span>&times;</span>
      </button>
      <h3 class="modal-title">Find your doctor</h3>
    </div>
    <div class="practice-search-modal-body">
      <h4>Search for the practice that you would like to connect to</h4>
      <practice-search v-on:practice="practice"></practice-search>
    </div>
    <div v-if="chosenPractice" class="text-center alert alert-success" role="alert">
      <i class="glyphicon glyphicon-user" aria-hidden="true">
      </i>
      You have selected {{chosenPractice.name | upperCase }}. Would you like to continue?
    </div>
    <div v-if="errorOccured" class="text-center alert alert-danger" role="alert">
      <i class="glyphicon glyphicon-exclamation-sign" aria-hidden="true">
      </i> Could not load the practice forms. Please contact <u>support@logbox.co.za</u> for assistance.
    </div>
    <div class="row" slot="footer">
      <div class="float-left col-xs-4 col-xs-offset-1">
        <button class="btn btn-secondary btn-block btn-close" @click="close">Close</button>
      </div>
      <div class="float-right col-xs-4 col-xs-offset-2">
        <button
          class="btn btn-primary btn-block"
          :disabled="!chosenPractice"
          @click="redirectToKioskSite(link)"
        >Continue</button>
      </div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from 'components/common/modals/BaseModal';
import PracticeSearch from 'components/common/inputs/PracticeSearch';

export default {
  name: 'kiosk-modal',
  data() {
    return {
      chosenPractice: null,
      link: null,
      errorOccured: false,
    };
  },
  props: {
    openModal: Boolean,
  },
  components: {
    BaseModal,
    PracticeSearch,
  },
  methods: {
    redirectToKioskSite(link) {
      if (link) {
        window.location.href = link;
      }
    },
    practice(val) {
      this.chosenPractice = val;
    },
    close() {
      this.chosenPractice = null;
      this.$emit('close');
    },
    async fetchKioskLink(id) {
      this.errorOccured = false;
      await this.$api.fetchPracticeKioskLink(id).then((response) => {
        this.link = response.url;
      })
      .catch(() => {
        this.errorOccured = true;
        this.link = null;
        this.chosenPractice = null;
      });
    },
  },
  filters: {
    upperCase(val) {
      return val ? val.toUpperCase() : '';
    },
  },
  watch: {
    chosenPractice(practice) {
      if (practice) {
        this.fetchKioskLink(practice.id);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// KioskModal.vue?2e4b93c7